import React from 'react';
import { observer } from 'mobx-react-lite';
import { ElementState } from '../../renderer/ElementState';

import PropertyDropdown from '../common/PropertyDropdown';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { useStore } from '@src/stores-v2/StoreContext';

interface PropertySelectProps {
  activeElement: ElementState;
  propertyName: string;
  defaultValue: any;
  options: Array<{ caption: string; value: any }>;
}

export const PropertySelect: React.FC<PropertySelectProps> = observer(
  (props) => {
    const videoCreator = useVideoCreatorStore();
    const { editorStore } = useStore();

    // Helper function to update property using headless editor or fallback to legacy
    const updateProperty = async (propertyName: string, value: any) => {
      if (editorStore?.headlessEnabled && editorStore?.editor && props.activeElement?.source?.id) {
        // Use headless editor UpdateElementCommand
        const success = editorStore.editor.commandUpdateElement(
          props.activeElement.source.id,
          { [propertyName]: value }
        );
        
        if (!success) {
          console.warn(`Failed to update element property ${propertyName}:`, value);
          // Fallback to legacy method
          await videoCreator.applyVideoStateModifications(
            {
              [`${props.activeElement.source.id}.${propertyName}`]: value,
            },
            true,
            `modifying ${props.activeElement.source.type} element`,
          );
        }
      } else {
        // Fallback to legacy method
        await videoCreator.applyVideoStateModifications(
          {
            [`${props.activeElement.source.id}.${propertyName}`]: value,
          },
          true,
          `modifying ${props.activeElement.source.type} element`,
        );
      }
    };

    return (
      <PropertyDropdown
        value={
          props.activeElement.source[props.propertyName] ?? props.defaultValue
        }
        onChange={async (value) => {
          await updateProperty(props.propertyName, value);
        }}
        defaultValue={
          props.activeElement.source[props.propertyName] ?? props.defaultValue
        }
        values={props.options.map(({ value, caption }) => ({ value, caption }))}
      />
    );
  },
);
